import { Button, VisuallyHidden } from "@hopper-ui/components";
import { CheckmarkIcon, CopyIcon } from "@hopper-ui/icons";
import type { ReactNode, Ref } from "react";
import { useCopyToClipboard } from "../hooks/useCopyToClipboard.ts";
import styles from "./CopyRowButton.module.css";

export interface CopyRowButtonProps {
    ref?: Ref<HTMLButtonElement>;
    value: string;
    label: ReactNode;
    errorMessage: string;
    onCopy?: () => void;
    children: ReactNode;
}

export function CopyRowButton({ ref, value, label, errorMessage, onCopy, children }: CopyRowButtonProps) {
    const { copy, isCopied } = useCopyToClipboard(errorMessage);

    async function handleCopy() {
        onCopy?.();
        await copy(value);
    }

    return (
        <Button
            ref={ref}
            variant="ghost-secondary"
            size="xs"
            minWidth={0}
            maxWidth="100%"
            UNSAFE_marginLeft="calc(-1 * (var(--hop-space-inset-xs) + var(--hop-space-10)))"
            className={styles.button}
            onPress={handleCopy}
        >
            {label}
            <VisuallyHidden>{value}</VisuallyHidden>
            {children}
            {isCopied ? (
                <CheckmarkIcon slot="end-icon" size="sm" fill="success" />
            ) : (
                <CopyIcon slot="end-icon" size="sm" className={styles.copyIcon} />
            )}
        </Button>
    );
}
